import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import messages from './ScheduleCalendar.messages';
import './ScheduleCalendar.scss';

const { block, element } = bem('schedule-calendar-legend');

const ScheduleCalendarLegend = () => {
  // The day cells carrying data-tip only exist while the picker dropdown is open, which is exactly
  // this legend's lifetime, so rebinding here covers opening the dropdown and changing month without
  // rebuilding on every Schedule page render.
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <ul className={block()}>
      <li className={element('item')}>
        <span className={element('swatch', { waiting: true })} />
        <Message message={messages.legendWaiting} />
      </li>
      <li className={element('item')}>
        <span className={element('swatch', { noClasses: true })} />
        <Message message={messages.legendNoClasses} />
      </li>
    </ul>
  );
};

export default ScheduleCalendarLegend;
